import { Info } from "@mui/icons-material";
import React from "react";
import { IconButton, Popover, Link, styled, Tooltip, TooltipProps, tooltipClasses } from "@mui/material";

type IProps = {
  showmore: Boolean;
  toggleMore: () => void;
  isShowLess: Boolean;
}

const XTooltip: React.FC<React.PropsWithChildren<IProps>> = ({ showmore, isShowLess, toggleMore, children }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = () => {
    toggleMore();
  }

  const open = Boolean(anchorEl);
  const renderText = isShowLess ? 'Show less' : 'Show more';
  return <React.Fragment>
    <IconButton
      aria-haspopup="true"
      // onMouseEnter={handlePopoverOpen}
      onClick={handlePopoverOpen}
    // onMouseLeave={handlePopoverClose}
    >
      <Info color="error" fontSize="small" />
    </IconButton>
    <Popover
      id="mouse-over-popover"
      className="tooltip-wrapper"
      // sx={{ pointerEvents: 'none' }}
      open={open}
      elevation={10}
      anchorEl={anchorEl}
      // placement="bottom-end"
      disablePortal={true}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={handlePopoverClose}
      slotProps={{
        paper: {
          className: 'tooltip-paper'
        }
      }}
    >
      {/* <Paper className="tooltip-paper"> this need to removed*/}

      <div className='avail-compact-view-item'>
        <div className="tootip-head cell">Qty</div>
        <div className="tootip-head cell">
          Order By
        </div>
        <div className="tootip-head cell">
          Delivered By
        </div>
        <div className="tootip-head cell">
          Store Location
        </div>
      </div>
      {children}
      <tr className='see-more-wrapper'>
        <td className='cell' colSpan={5}>
          <div className="cell-link">
            {showmore ? <Link className="link-btn" component="button" color="primary" variant="body2" onClick={handleToggle}>{renderText}</Link> : <span />}
            <Link className="link-btn" component="button" variant="body1" onClick={handlePopoverClose}>Close</Link>
          </div>
        </td>
      </tr>
      {/* </Paper> */}
    </Popover>

  </React.Fragment>
}

export default XTooltip;

export const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));
